<template>
  <footer
    class="h-[110px] mt-[40px] flex text-white items-center justify-center lg:justify-end px-44"
    :style="{ backgroundColor: bgColor || '#2C9EB3' }"
  >
    <a :href="companyUrl" target="_blank" class="font-normal">
      {{ `© ${companyName} ${year || defaultYear?.getFullYear()}` }}
    </a>
  </footer>
</template>

<script setup lang="ts">
const defaultYear = ref(new Date());

withDefaults(
  defineProps<{
    bgColor?: string;
    companyUrl?: string;
    companyName?: string;
    year?: number;
  }>(),
  {
    bgColor: '#2C9EB3',
    companyUrl: 'https://www.niloosoft.com',
    companyName: 'Niloosoft',
  }
);
</script>

<style scoped></style>
